import type { CatalogoDescriptor } from '@next/compartilhados/catalogos'

import type { TipoPerfilDePermissao } from '../../perfil-de-permissao/catalogo'

export type PerfilDaOpcaoUsuario = Readonly<{ id?: string | null, name?: string | null, kind?: TipoPerfilDePermissao | null }>

export type OpcaoUsuario = Readonly<{
  id: string
  name: string
  email: string
  roleGroup?: PerfilDaOpcaoUsuario | null
  compemployee?: Readonly<{ id?: string | null }> | null
}>

export type FiltrosCatalogoUsuario = Readonly<{
  roleGroup?: Readonly<{ id?: readonly string[], kind?: readonly TipoPerfilDePermissao[] }>
}>

export type SelecaoCatalogoUsuario = OpcaoUsuario | readonly OpcaoUsuario[] | null
export type OperacoesCatalogoUsuario = Readonly<{ listarOpcoes: (sinal: AbortSignal) => Promise<readonly OpcaoUsuario[]> }>

const CAMPOS_PROJECAO = new Set(['id', 'name', 'email', 'roleGroup', 'compemployee'])

const camposRelacoes = {"roleGroup": ["id", "name", "kind"], "compemployee": ["id"]}
const validarRelacao = (valor: unknown, campos: readonly string[]): boolean => {
  if (typeof valor !== 'object' || valor === null) return true
  if (Array.isArray(valor)) return valor.every(item => validarRelacao(item, campos))
  return Object.keys(valor).every(campo => campos.includes(campo))
}

export const DESCRITOR_CATALOGO_USUARIO: CatalogoDescriptor<OpcaoUsuario> = Object.freeze({
  nome: 'usuarios',
  versaoProjecao: 3,
  validarItens: (valor: unknown): valor is readonly OpcaoUsuario[] => (
    Array.isArray(valor) && valor.every((item: unknown) => typeof item === 'object' && item !== null && !Array.isArray(item)
      && Object.keys(item).every(campo => CAMPOS_PROJECAO.has(campo))
      && Object.entries(camposRelacoes).every(([campo, permitidos]) => validarRelacao((item as Record<string, unknown>)[campo], permitidos)))
  ),
})
